/**
 * Sidebar scroll helpers for the admin guided tour. The tour runs inside a
 * Radix ScrollArea; these keep the spotlight target visible in the scroll viewport.
 */
export const SIDEBAR_VIEWPORT_SELECTOR =
  "[data-testid='admin-sidebar'] [data-radix-scroll-area-viewport]";

export const scrollSidebarToTop = (): void => {
  const viewport = document.querySelector<HTMLElement>(
    SIDEBAR_VIEWPORT_SELECTOR,
  );
  if (!viewport) return;
  viewport.scrollTop = 0;
};

/** Centers the target vertically in the sidebar scroll viewport. */
export const scrollTargetIntoSidebar = (targetSelector: string): void => {
  const viewport = document.querySelector<HTMLElement>(
    SIDEBAR_VIEWPORT_SELECTOR,
  );
  const target = document.querySelector<HTMLElement>(targetSelector);
  if (!viewport || !target) return;
  const relativeTop =
    target.getBoundingClientRect().top -
    viewport.getBoundingClientRect().top +
    viewport.scrollTop;
  viewport.scrollTop =
    relativeTop - viewport.clientHeight / 2 + target.offsetHeight / 2;
};
